export function formatRepetitions(value: number) {
  const mod100 = value % 100
  const mod10 = value % 10
  const word = mod100 >= 11 && mod100 <= 14 ? 'повторений' : mod10 === 1 ? 'повторение' : mod10 >= 2 && mod10 <= 4 ? 'повторения' : 'повторений'
  return `${value} ${word}`
}

export function formatSeconds(value: number) {
  const mod100 = value % 100
  const mod10 = value % 10
  const word = mod100 >= 11 && mod100 <= 14 ? 'секунд' : mod10 === 1 ? 'секунда' : mod10 >= 2 && mod10 <= 4 ? 'секунды' : 'секунд'
  return `${value} ${word}`
}
